import DownloadSVG from '@public/icons/download.svg';
import ArrSVG from '@public/icons/small-arrow.svg';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Document } from '@/entities/document';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import { isPdf } from '@/shared/hooks/use-form-sender/validator/utils';
import { getDocumentIconComponentByUrl } from '@/shared/lib/utils/get-document-icon-component-by-url';
import DocumentLink from '../DocumentLink';
import Dropdown from '../Dropdown';

type Props = React.HTMLAttributes<HTMLElement> & {
    title?: string;
    documents: Document[];
};

const SectionDocs = forwardRef<HTMLDivElement, Props>(({ documents, title = 'Документы', ...props }, ref) => {
    const device = useMediaQueryDeviceStateValue();
    const isDesktop = device.includes('desktop');

    return (
        <div {...props} ref={ref} className={classNames('section-docs', props.className)}>
            {isDesktop ? (
                documents.map((document, i) => <DocumentLink document={document} key={i} />)
            ) : documents.length > 1 ? (
                <Dropdown className={'header-btn expo-docs-btn middle-out'}>
                    <Dropdown.Toggler className="header-btn__toggler">
                        <span className="text-xs">{title}</span>
                        <ArrSVG className="header-arrow-svg" />
                    </Dropdown.Toggler>

                    <Dropdown.Content className="header-btn__content" position="bottom-right">
                        <ul className="list-unstyled menu-dropdown-list">
                            {documents.map((doc, i) => {
                                const DocIconComponent = getDocumentIconComponentByUrl(doc.src);

                                return (
                                    <Dropdown.Picker
                                        tag="li"
                                        className="dropdown-list__item expo-dropdown-list__item"
                                        key={i}
                                    >
                                        <a
                                            className="menu-dropdown-link expo-menu-dropdown-link text-xs"
                                            href={doc.src}
                                            target={isPdf(doc.src) ? '_blank' : undefined}
                                            rel={isPdf(doc.src) ? 'noreferrer noopener' : undefined}
                                            download={isPdf(doc.src) ? undefined : true}
                                        >
                                            <div className="dropdown-list__item-wrapper">
                                                {DocIconComponent && (
                                                    <DocIconComponent className="pdf-svg expo-pdf-svg" />
                                                )}
                                                <span>{doc.title}</span>
                                            </div>

                                            <DownloadSVG className="download-svg" />
                                        </a>
                                    </Dropdown.Picker>
                                );
                            })}
                        </ul>
                    </Dropdown.Content>
                </Dropdown>
            ) : (
                <DocumentLink document={documents[0]} />
            )}
        </div>
    );
});

SectionDocs.displayName = 'SectionDocs';

export default SectionDocs;
